import React from "react";
import Seo from "@/utils/seo";
import Section from "@/components/ui/section";
import Image from "next/image";
export default function ContactUs() {
  const data = [
    {
      id: "1",
      icon: "/images/icons/mobile.svg",
      value: "+91 98183 14184",
      href: "tel:+919818314184",
    },
    {
      id: "2",
      icon: "/images/icons/email.svg",
      value: "rajeev@rosebowl.in",
      href: "mailto:rajeev@rosebowl.in",
    },
  ];
  return (
    <>
      <Seo metaTitle={`Contact Us | Rose Bowl`} slug={`contact-us`} />
      <Section>
        <div className="flex lg:flex-row-reverse flex-col-reverse items-center lg:gap-20 gap-6 md:mt-[120px] mt-[90px]">
          <div className="flex flex-col w-full gap-3">
            <h1 className="text-darkGrey uppercase font-havletica font-thin lg:text-[40px] md:text-[36px] text-[28px] leading-tight">
              Say Hello!
            </h1>
            <div className="flex lg:flex-row flex-col border-t-[0.5px] border-darkGrey/50 border-b-[0.5px] lg:justify-start lg:items-center lg:gap-20 gap-6 py-5">
              {data.map((e) => (
                <a
                  href={e.href}
                  target="_blank"
                  rel="noreferrer"
                  key={e.id}
                  className="flex items-center gap-4 text-sm md:text-base text-darkGrey hover:underline transition-all duration-300 ease"
                >
                  <div className="relative w-10 h-10 shrink-0">
                    <Image
                      src={e.icon}
                      alt="icon"
                      fill
                      className="object-center object-contain"
                      sizes="(max-width: 479px) 100px, 100px"
                    />
                  </div>
                  <span className="lg:max-w-[343px]">{e.value}</span>
                </a>
              ))}
            </div>
          </div>
          <div className="relative lg:w-[400px] w-full md:h-[350px] h-[250px] shrink-0 rounded-2xl overflow-hidden">
            <Image
              src="/images/hello.webp"
              fill
              alt="contact us"
              className="object-cover object-center w-full h-full"
              sizes="(max-width: 768px) 400px, (max-width: 1200px) 400px, 400px"
            />
          </div>
        </div>
      </Section>
    </>
  );
}
